module.exports = __webpack_public_path__ + "static/media/email_icon.10be52ff.svg";